export const enChatStrings = {
    deleteConfirmation: "Are you sure you want to delete this message?",
    deleteModalTitle: "Confirmation to delete message",
    deleteConfirmationMember: "Are you sure you want to delete this user?",
    deleteMemberTitle: "Confirmation to remove user ",
    leaveGroupConfirmation: "Are you sure you want to leave this channel?",
    leaveGroupTitle: "Confirmation to leave group",
    yesterdayDateFns: "'Yesterday'",
    todayDateFns: "'Today'",
    literalDayDateFns: "eeee",
    dateFns: "dd.MM.yyyy",
    messageInputPlaceholder: "Message #",
    statusDisconnected: "✖️ Disconnected",
    statusConnecting: "Connecting...",
    statusTryingToReconnect: "✖️ Disconnected. Trying to reconnect...",
    newMessages: "New",
    currentSender: "You",
    noChannelsMessage: "You don't have any conversations yet. You can start a conversation with the top left button!",
    headerDM: "Direct messages",
    headerGM: "Group messages",
    headerUM: "Unread messages",
    groupTitle: "Group title",
    searchUsers: "Search for users",
    searchConversations: "Search conversations",
    typeUser: "Type in user's name",
};
export const deChatStrings = {
    deleteConfirmation: "Bist Du sicher, dass Du diese Nachricht löschen möchtest?",
    deleteModalTitle: "Bestätigung zum Löschen der Nachricht ",
    deleteConfirmationMember: "Möchten Sie diesen Benutzer wirklich löschen?",
    deleteMemberTitle: "Bestätigung zum Entfernen des Benutzers ",
    leaveGroupConfirmation: "Möchten Sie diesen Kanal wirklich verlassen?",
    leaveGroupTitle: "Bestätigung zum Verlassen der Gruppe",
    yesterdayDateFns: "'Gestern'",
    todayDateFns: "'Heute'",
    literalDayDateFns: "eeee",
    dateFns: "dd.MM.yyyy",
    messageInputPlaceholder: "Nachricht #",
    statusDisconnected: "✖️ Getrennt",
    statusConnecting: "Anschließen...",
    statusTryingToReconnect: "✖️ Verbindung unterbrochen. Verbindung wird wieder hergestell...",
    newMessages: "Neu",
    currentSender: "Du",
    noChannelsMessage: "Du hast noch keine Unterhaltungen. Starte eine Unterhaltung über den Button oben links!",
    headerDM: "Direktnachrichten",
    headerGM: "Gruppennachrichten",
    headerUM: "Ungelesene Nachrichten",
    groupTitle: "Gruppentitel",
    searchUsers: "Nach Benutzern suchen",
    searchConversations: "Nach Konversationen suchen",
    typeUser: "Geben Sie den Benutzernamen ein",
};
//# sourceMappingURL=strings.js.map